/* unplugin-vue-components disabled */import script from "./CustomTab.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomTab.vue?vue&type=script&setup=true&lang=js"

import "./CustomTab.vue?vue&type=style&index=0&id=0af38c5a&lang=less&scoped=true"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/e652ddcf-2c47-4325-b31c-639f40aeccc9/workspace/mobile-FTZCOIN_ILBL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0af38c5a"]])

export default __exports__